<template>
  <div class="table-detail">
    <div class="row">
      <div class="col-xs-12 col-sm-2">
        <div class="text-center">
          <img height="150" class="thumbnail inline no-margin-bottom" alt="user-avatar" :src="showAvatar(item.thumbnail)" />
          <br />
          <br />
          <button class="btn btn-info edit-bottom" type="button" @click="handleEdit(item.userId)" v-if="isAdmin === 'true'">編集</button>
        </div>
      </div>
      <div class="col-xs-12 col-sm-10">
        <div class="col-sm-12 col-xs-12">
          <div id="accordion" class="accordion-style1 panel-group">
            <app-user-detail-account v-bind:item="item"></app-user-detail-account>
            <app-user-detail-device v-bind:item="item"></app-user-detail-device>
            <app-user-detail-gate v-bind:item="item"></app-user-detail-gate>
            <app-user-detail-group v-bind:item="item"></app-user-detail-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserDetailAccount from './UserDetailAccount.vue'
import UserDetailDevice from './UserDetailDevice.vue'
import UserDetailGate from './UserDetailGate.vue'
import UserDetailGroup from './UserDetailGroup.vue'

export default {
  props: ['item', 'isAdmin'],
  data () {
    return {
    }
  },
  components: {
    appUserDetailAccount: UserDetailAccount,
    appUserDetailDevice: UserDetailDevice,
    appUserDetailGate: UserDetailGate,
    appUserDetailGroup: UserDetailGroup
  },
  methods: {
    showAvatar (imgdata) {
      return 'data:image/png;base64,' + imgdata
    },
    // ユーザー編集
    handleEdit (id) {
      this.$router.push({name: 'useredit', query: { id: id }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/UserDetail.vue